module.exports = __webpack_public_path__ + "static/media/sewrlyTextLogoShadow.cc78553e.svg";